import React from 'react'
import { useSelector } from 'react-redux'

const WhyStashfin = () => {

  const {cityData} = useSelector((state) => state.CityWiseIplReducer)
  
  return (
    <section id="glance" className='why-stashfin'>
      <div className='heading'>
         Live the life you deserve in <br/> {cityData?.city}  with Stashfin Loans
      </div>
      <div className='desc-1'>
         {cityData?.content}
      </div>
    </section>
  )
}
export default WhyStashfin
